export const FILTER_POPOVER_WIDTH = '540px';

/**
 * The layers a field inside the popper opens outside it: an Autocomplete's list, a select's menu, a date
 * picker, a dialog. MUI portals them to the end of `body`, so to the DOM a click in one is a click outside
 * the paper. The ones rendered from inside the popper's React tree are already caught by
 * `ClickAwayListener` itself; this list is for the rest — a layer opened by a field that portals through a
 * store or a context, or one still fading out after it lost its React owner — so a pick is never read as
 * "click outside" and closes the popper under the planner's hand.
 */
export const FILTER_POPPER_PORTALED_LAYER_SELECTORS = [
  '.MuiAutocomplete-popper',
  '.MuiPopover-root',
  '.MuiMenu-root',
  '.MuiPickersPopper-root',
  '.MuiDialog-root'
].join(', ');
